import React, { useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { usePostAppAuthenticationAdvisorconnectInvoke } from '@/api';
import { Loader } from '@/components/Loader/loader';
import { ROUTE } from '@/constants/route';
import { USER_TYPE } from '@/enums/userType';
import { useAuth } from '@/hooks/useAuth';
import { useUserStore } from '@/store/useStore';
import { log } from '@/utils/functions/logger/logger';

const VueConseiller: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const setUser = useUserStore((state) => state.setUser);
  const { mutate, isPending, isError } = usePostAppAuthenticationAdvisorconnectInvoke();
  const params = useParams();
  const token = params.token as string;
  useEffect(() => {
    mutate(
      {
        data: { advisorToken: token },
      },
      {
        onSuccess: (data) => {
          const advisorData = { ...data, type: USER_TYPE.client };
          setUser(advisorData);
          if (data.success) {
            sessionStorage.setItem('authToken', data.token ?? '');
            sessionStorage.setItem('islogin', 'true');
            navigate(ROUTE.DASHBOARD);
            login(advisorData);
          }
        },
        onError: (error) => {
          log.error(`VueConseiller: Error during authentication: ${String(error)}`);
        },
      }
    );
  }, [mutate, setUser, token, navigate, login]);

  return (
    <div>
      <h1>Vue Conseiller</h1>
      {isPending ? <Loader /> : null}
      {isError ? <p>Erreur dauthentification</p> : null}
    </div>
  );
};

export default VueConseiller;
